import { Box, Switch, Typography } from "@mui/material";
import React, { Dispatch } from "react";

interface SkillEvaluationProps {
	newAddOnSettings: any; // TODO: Define type
	setNewAddOnSettings: Dispatch<any>;
}

const SkillEvaluation: React.FC<SkillEvaluationProps> = ({
	newAddOnSettings,
	setNewAddOnSettings,
}) => {
	return (
		<Box
			sx={{
				backgroundColor: "#F5F5F5",
				borderRadius: "8px",
				marginTop: "32px",
				padding: "16px",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "16px",
							color: "rgba(0, 0, 0, 0.87)",
						}}
					>
						Skill Evaluation
					</Typography>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "12px",
							color: "rgba(0, 0, 0, 0.6)",
						}}
					>
						Enable skill evaluation for workers.
					</Typography>
				</Box>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Switch
						checked={newAddOnSettings.skillEvaluationFormEnabled ?? false}
						onChange={(e) => {
							setNewAddOnSettings((pre: any) => ({
								...pre,
								skillEvaluationFormEnabled: e.target.checked,
							}));
						}}
					/>
				</Box>
			</Box>
		</Box>
	);
};

export default SkillEvaluation;
